import React from "react";

import { useTranslation } from "react-i18next";

import { Select } from "antd";

import { Inscription } from "../../inscription";

import styles from "./styles.module.scss";

const { Option } = Select;

export interface CurrencySelectorProps {
  value?: string;
  onSelect: (currency: string) => void;
}

export const CurrencySelector: React.FC<CurrencySelectorProps> = (props) => {
  const { onSelect, value } = props;
  const { t } = useTranslation("currency_selector");

  const currencies = [
    { code: "RUB", emoji: "🇷🇺" },
    { code: "EUR", emoji: "🇪🇺" },
    { code: "USD", emoji: "🇺🇸" },
    { code: "CNY", emoji: "🇨🇳" },
    { code: "UAH", emoji: "🇺🇦" },
    { code: "KZT", emoji: "🇰🇿" },
    { code: "AZN", emoji: "🇦🇿" },
    { code: "BYN", emoji: "🇧🇾" },
    { code: "THB", emoji: "🇹🇭" },
    { code: "KGS", emoji: "🇰🇬" },
    { code: "UZS", emoji: "🇺🇿" },
    { code: "TZS", emoji: "🇹🇿" },
    { code: "KES", emoji: "🇰🇪" },
    { code: "ZAR", emoji: "🇿🇦" },
  ];

  return (
    <Inscription title={t("title")}>
      <Select showSearch className={styles.select} value={value} placeholder={t("placeholder")} onSelect={onSelect}>
        {currencies.map(({ code, emoji }, idx) => (
          <Option key={`currency-option-${idx}`} value={code}>
            <span className={styles.icon} role="img" title={`flag-${code}`}>
              {emoji}
            </span>
            <span className={styles.option}>{code}</span>
          </Option>
        ))}
      </Select>
    </Inscription>
  );
};
